@if (featureEnabled) {
  <ng-content></ng-content>
}
